import * as React from "react";

export interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundImage: [
          "radial-gradient(ellipse 80% 60% at 50% 0%, hsl(var(--foreground) / 0.05) 0%, transparent 60%)",
          "linear-gradient(hsl(var(--foreground) / 0.03) 1px, transparent 1px)",
          "linear-gradient(90deg, hsl(var(--foreground) / 0.03) 1px, transparent 1px)",
        ].join(", "),
        backgroundSize: "auto, 48px 48px, 48px 48px",
      }}
    >
      <a
        href="/"
        className="mb-8 flex items-center gap-[0.5ch] whitespace-nowrap text-2xl font-normal text-foreground no-underline hover:opacity-80 transition-opacity"
        style={{ fontFamily: "var(--font-logo)" }}
      >
        <span>{"|--k>"}</span>
        <span>kopai</span>
      </a>
      {children}
    </div>
  );
}
